import { BaseResponse } from './internal/baseresponse';
export class TransactionPendingResult extends BaseResponse {
  data: null;
}



// WEBPACK FOOTER //
// ./src/app/response/transactionpendingresult.ts